import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { debounce, isEmpty } from 'lodash';

import { Form } from 'react-bootstrap-5';

import { createNote, fetchInsightsPropertyNote, updateNote } from 'helpers/clarity_api';

export default function PropertyNotes({ id }) {
  const [notes, setNotes] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    fetchInsightsPropertyNote(id).then(setNotes);
  }, []);

  const autosave = debounce((description) => {
    if (isEmpty(description)) return;

    if (notes?.id) {
      updateNote(notes.id, description);
    } else {
      inputRef.current.disabled = true;

      createNote({
        body: description,
        notable_id: id,
        notable_type: 'Insights::Property'
      }).then((notes) => {
        inputRef.current.disabled = false;

        setNotes(notes);
      });
    }
  }, 1000);

  return (
    <Form.Group>
      <Form.Label>Notes about this property</Form.Label>
      <Form.Control
        as="textarea"
        defaultValue={notes?.body}
        ref={inputRef}
        rows={5}
        onChange={e => autosave(e.target.value)}
      />
    </Form.Group>
  );
}

PropertyNotes.propTypes = {
  id: PropTypes.number.isRequired
};
